import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-dialog-alterar-senha',
  templateUrl: './dialog-alterar-senha.component.html',
  styleUrls: ['./dialog-alterar-senha.component.css']
})
export class DialogAlterarSenhaComponent {
  public salvando = false;
  public esconderSenhaAtual = true;
  public esconderNovaSenha = true;
  public esconderConfirmacao = true;
  public senhaForm = new FormGroup({
    senhaAtual: new FormControl('', [Validators.required]),
    novaSenha: new FormControl('', [Validators.required, Validators.minLength(5)]),
    confirmarNovaSenha: new FormControl('', [Validators.required])
  });

  public constructor(
    private httpClient: HttpClient,
    private dialogRef: MatDialogRef<DialogAlterarSenhaComponent>,
    private snackBarService: SnackBarService
  ) { }

  public salvar(): void {
    if (this.salvando) {
      return;
    }

    this.validarConfirmacao();
    if (this.senhaForm.invalid) {
      this.senhaForm.markAllAsTouched();
      return;
    }

    const valores = this.senhaForm.getRawValue();

    this.salvando = true;
    this.httpClient.put('/api/Usuarios/MinhaSenha', {
      senhaAtual: valores.senhaAtual,
      novaSenha: valores.novaSenha
    }).subscribe({
      next: () => {
        this.snackBarService.exibirSucesso('Senha alterada com sucesso!');
        this.dialogRef.close(true);
      },
      error: erro => {
        this.salvando = false;
        this.snackBarService.exibirErro(erro?.error?.message ?? 'Não foi possível alterar a senha.');
      }
    });
  }

  public cancelar(): void {
    if (!this.salvando) this.dialogRef.close();
  }

  public validarConfirmacao(): void {
    const controle = this.senhaForm.controls.confirmarNovaSenha;
    const erros = { ...(controle.errors ?? {}) };

    if (controle.value && controle.value !== this.senhaForm.controls.novaSenha.value) {
      controle.setErrors({ ...erros, diferente: true });
      return;
    }

    delete erros['diferente'];
    controle.setErrors(Object.keys(erros).length ? erros : null);
  }
}
